define('core/templates/postMediaUploadButton',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<a href=\"#\" tabindex=\"-1\" data-action=\"attach\" class=\"attach\" title=\""
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Upload Images",{"name":"gettext","hash":{},"data":data}))
    + "\">\n<div class=\"wysiwyg__attach wysiwyg__attach-dims\"\nrole=\"img\"\naria-label=\"A\"\n/>\n</a>\n<input type=\"file\" data-role=\"media-upload\" tabindex=\"-1\" accept=\"image/*\">\n";
},"useData":true})

});
